module.exports = __webpack_public_path__ + "static/media/AI-手柄-电机驱动-新.a2e4aaaf.jpg";